import { first, map } from 'rxjs/operators';
import Router, { RouteConfig } from 'vue-router';

import { AuthService } from '@skinsoft/auth';
import { router as _router } from '../../apps/condition-report/src/router';
import { Home } from './app/component/home';
import { Login } from './auth/page/login';

export enum Routes {
    LOGIN = 'login',
    HOME = 'home',
    CONDITION_REPORT = 'condition-report',
    TRACKING = 'tracking',

    // // tracking
    DASHBOARD = 'dashboard',
    MOVEMENT = 'movement',
    MOVEMENTS = 'movements',
    TASK = 'task',
    TASKS = 'tasks',
}

export const router = new Router({
    mode: 'history',
    routes: [
        {
            component: Home,
            name: Routes.HOME,
            path: '/',
        },
        {
            component: Login,
            name: Routes.LOGIN,
            path: '/login',
        }
    ]
})

/**
 * Allows to add routes from standalone applications
 * @param routesToAdd 
 */
export const addRoutes = (routesToAdd: RouteConfig[]) => {
    // filter doubles
    router.addRoutes(routesToAdd)
}

router.beforeEach((to, __, next) => {
    AuthService.getInstance()
        .waitForUser$()
        .pipe(
            first(),
            map(authenticated => {
                if (!(authenticated && authenticated.user) && to.name !== Routes.LOGIN) {
                    return { name: Routes.LOGIN };
                }

                if (authenticated && authenticated.user && to.name === Routes.LOGIN) {
                    return false;
                }

                return;
            }),
        )
        .subscribe(next);
});
